import React from 'react'

interface FileReviewPopupErrorsProps {
    numComplete: number
    numErrors: number
}

const FileReviewPopupErrors = (props: FileReviewPopupErrorsProps) => {
    const { numComplete, numErrors } = props
    return (
        <div className="info-head">
            <h3>You&apos;re almost done!</h3>
            <p>
                You have
                {numComplete ? (
                    <>
                        <span className="bold"> {numComplete}</span>
                        work{numComplete === 1 ? ' ' : 's '}
                        that {numComplete === 1 ? 'is' : 'are'} ready to submit and{' '}
                    </>
                ) : null}
                <span className="bold"> {numErrors} </span>
                work{numErrors === 1 ? '' : 's'} {numComplete ? '' : 'that '}
                still need{numErrors === 1 ? 's' : ''} attention. Please review and resolve errors in order to submit
                all your works.
            </p>
        </div>
    )
}

export default FileReviewPopupErrors
